// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  endpointQC: 'https://gdb.ci-uat.net/qc-api/v1.0',
  qcURL: 'https://gdb.uat.qivos.net/qc-api/v1.0',
  qcEndpointPublic: 'https://gdb.uat.qivos.net/qc-api/v1.0/public/',
  qcEndpointProtected: 'https://gdb.uat.qivos.net/qc-api/v1.0/protected/',
  qivosApiURL: 'https://api-staging.qivos.net',
  qivosRestURL: 'https://gdb.uat.qivos.net/rest-ci-gdb-UAT/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
